export abstract class AuthService {
    useNativeAuth: boolean;
    Me: any;
    abstract check(): angular.IPromise<void>;
    abstract signIn(email: string, password: string): angular.IPromise<any>;
    abstract signInGithub(repoScope: boolean): angular.IPromise<void>;
    abstract signInSteam(): angular.IPromise<void>;
    abstract signInSteamByTicket(): angular.IPromise<void>;
    abstract signOut(): void;
    abstract set(token: string): angular.IPromise<void>;
    abstract required(): boolean;
}

export function AuthServiceFactory($injector: angular.auto.IInjectorService) {
    return $injector.get('Auth');
}

export const AuthServiceProvider = {
    provide: AuthService,
    useFactory: AuthServiceFactory,
    deps: ['$injector']
};